const Precipitation = () => {
  const data = [
    {
      month: "Oct",
      values: [
        {
          value: 1.19,
          category: "2006-2020 Average",
          month: "Oct",
        },
        {
          value: 0.64,
          category: "WY2020",
          month: "Oct",
        },
      ],
    },
    {
      month: "Nov",
      values: [
        {
          value: 0.41,
          category: "2006-2020 Average",
          month: "Nov",
        },
        {
          value: 0.54,
          category: "WY2020",
          month: "Nov",
        },
      ],
    },
    {
      month: "Dec",
      values: [
        {
          value: 0.44,
          category: "2006-2020 Average",
          month: "Dec",
        },
        {
          value: 0.16,
          category: "WY2020",
          month: "Dec",
        },
      ],
    },
    {
      month: "Jan",
      values: [
        {
          value: 0.29,
          category: "2006-2020 Average",
          month: "Jan",
        },
        {
          value: 0.13,
          category: "WY2020",
          month: "Jan",
        },
      ],
    },
    {
      month: "Feb",
      values: [
        {
          value: 0.53,
          category: "2006-2020 Average",
          month: "Feb",
        },
        {
          value: 0.91,
          category: "WY2020",
          month: "Feb",
        },
      ],
    },
    {
      month: "Mar",
      values: [
        {
          value: 1.02,
          category: "2006-2020 Average",
          month: "Mar",
        },
        {
          value: 1.21,
          category: "WY2020",
          month: "Mar",
        },
      ],
    },
    {
      month: "Apr",
      values: [
        {
          value: 1.63,
          category: "2006-2020 Average",
          month: "Apr",
        },
        {
          value: 0.43,
          category: "WY2020",
          month: "Apr",
        },
      ],
    },
    {
      month: "May",
      values: [
        {
          value: 2.18,
          category: "2006-2020 Average",
          month: "May",
        },
        {
          value: 1.16,
          category: "WY2020",
          month: "May",
        },
      ],
    },
    {
      month: "Jun",
      values: [
        {
          value: 1.83,
          category: "2006-2020 Average",
          month: "Jun",
        },
        {
          value: 1.13,
          category: "WY2020",
          month: "Jun",
        },
      ],
    },
    {
      month: "Jul",
      values: [
        {
          value: 2.11,
          category: "2006-2020 Average",
          month: "Jul",
        },
        {
          value: 0.51,
          category: "WY2020",
          month: "Jul",
        },
      ],
    },
    {
      month: "Aug",
      values: [
        {
          value: 1.72,
          category: "2006-2020 Average",
          month: "Aug",
        },
        {
          value: 0.22,
          category: "WY2020",
          month: "Aug",
        },
      ],
    },
    {
      month: "Sep",
      values: [
        {
          value: 1.44,
          category: "2006-2020 Average",
          month: "Sep",
        },
        {
          value: 0.54,
          category: "WY2020",
          month: "Sep",
        },
      ],
    },
  ];

  let tooltipCard;

  const createTooltip = month => {
    if (month !== null || typeof month !== "undefined") {
      const tooltipData = data.filter(d => d.month === month);

      if (document.querySelector(".tooltip-card-precip") !== null) {
        document.querySelector(".tooltip-card-precip").remove();
      }

      tooltipCard = d3
        .select("body")
        .append("div")
        .attr("class", "tooltip-card tooltip-card-precip");

      let html = "";
      if (tooltipData.length > 0) {
        html = `<div class="ts-tooltip-title">${tooltipData[0].month}</div>`;
        tooltipData[0].values.forEach((d, i) => {
          const legendStyle = `background: ${colors[i]}`;
          html += `
            <div class="ts-tooltip-value-wrapper">
              <div class="ts-tooltip-legend" style="${legendStyle}"></div>
              <div class="ts-tooltip-value">${d.category}: ${d.value} inches</div>
            </div>`;
        });
      }

      tooltipCard.html(html);
      const tooltipWidth = Number(tooltipCard.style("width").slice(0, -2));
      const xPos =
        document.body.offsetWidth / event.pageX < 1.3
          ? event.pageX - (tooltipWidth + 15)
          : event.pageX + 15;

      tooltipCard
        .style("opacity", 1)
        .style("left", `${xPos}px`)
        .style("top", `${event.pageY - 15}px`);
    }
  };

  const removeTooltip = () => {
    tooltipCard.style("opacity", 0);
  };

  d3.select("#precip-comparison-graph-section #graph svg").remove();
  const svg = d3
    .select("#precip-comparison-graph-section #graph")
    .append("svg");
  const mobile = document.body.offsetWidth < 769;

  const colors = ["#5c6bc0", "#23b578"];

  let initWidth = d3
    .select("#precip-comparison-graph-section #graph")
    .style("width");
  initWidth = parseInt(initWidth.substring(0, initWidth.length - 2));
  initWidth = mobile ? initWidth * 0.85 : initWidth * 0.95;
  const initHeight = initWidth * 0.45;

  const margin = { top: 15, right: 15, bottom: 25, left: 45 };
  const width = initWidth - margin.left - margin.right;
  const height = initHeight - margin.top - margin.bottom;

  svg
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom);

  const g = svg
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  const x0 = d3
    .scaleBand()
    .rangeRound([0, width])
    .paddingInner(0.1);
  const x1 = d3.scaleBand().padding(0.05);
  const y = d3.scaleLinear().rangeRound([height, 0]);

  x0.domain(data.map(d => d.month));
  x1.domain(["2006-2020 Average", "WY2020"]).rangeRound([0, x0.bandwidth()]);
  y.domain([0, 2.75]);

  g.append("g")
    .attr("class", "axis axis--x")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x0));

  g.append("g")
    .attr("class", "axis axis--y")
    .call(d3.axisLeft(y))
    .append("text")
    .attr("fill", "#000")
    .attr("y", 15)
    .attr("dy", "0.3em")
    .attr("transform", "rotate(-90)")
    .attr("text-anchor", "end")
    .style("font-size", "12px")
    .text("Precipitation (inches)");

  const slice = g
    .selectAll(".slice")
    .data(data)
    .enter()
    .append("g")
    .attr("class", "g")
    .attr("transform", d => `translate(${x0(d.month)},0)`);

  slice
    .selectAll("rect")
    .data(d => d.values)
    .enter()
    .append("rect")
    .attr("width", x1.bandwidth())
    .attr("x", d => x1(d.category))
    .style("fill", "#333333")
    .style("fill", (d, i) => colors[i])
    .attr("y", d => y(d.value))
    .attr("height", d => height - y(d.value))
    .on("mouseover", function(d, i) {
      createTooltip(d.month);
    })
    .on("mouseout", function(d, i) {
      removeTooltip(removeTooltip);
    });
};
